import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Card from "../../components/common/Card";
import Linechart from "../../components/DashboardComponents/LineChart";
import CardTab from "../../components/DashboardComponents/CardTab/CardTab";
import CampaignTable from "../../components/DashboardComponents/CampaignTable";

import {
  Container,
  CardWrapper,
  ChartWrapper,
  Wrapper,
  TableWrapper,
} from "./DashboardStyles";
import { getUserProfile } from "../../redux/slices/userSlice";
import { getTopBoard } from "../../redux/slices/dashboardSlice";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { topBoard } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(getUserProfile());
    dispatch(getTopBoard());
  }, [dispatch]);
  return (
    <Container>
      <div className="heading">
        <h1 style={{ textTransform: "capitalize" }}>
          Hey, {user.data?.firstName}
        </h1>
        <p>Track and manage your campaigns.</p>
      </div>
      <CardWrapper>
        <Card
          text={"Total no of campaigns"}
          totalCount={topBoard.totalCampaigns}
        />
        <Card
          text={"Total no of advertisers"}
          totalCount={topBoard.totalAdvertisers}
        />
        <Card
          text={"Total no of publishers"}
          totalCount={topBoard.totalPublishers}
        />
      </CardWrapper>
      
      <h3>Analytics</h3>
      <ChartWrapper>
        <Linechart />
      </ChartWrapper>
      <Wrapper>
        <CardTab title="Performing advertisers" advertisers />
        <CardTab title="Performing publishers" publishers />
      </Wrapper>

      <TableWrapper>
        <div className="header">
          <div className="texts">
            <h3>Top campaigns</h3>
            <p>Keep track of your Ads with MetaClick</p>
          </div>
          <div className="link-buttons">
            <Link className="see-more" to="/campaigns">
              See More
            </Link>
            <Link className="add-campaign" to="create-campaign">
              + Create Campaign
            </Link>
          </div>
        </div>
        <CampaignTable />
      </TableWrapper>
    </Container>
  );
};

export default Dashboard;
